"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _AccordionTransition = _interopRequireDefault(require("../transitions/AccordionTransition"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Functions = require("../core/Functions");

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UILink = _interopRequireDefault(require("../link/UILink"));

var _UINavItemLabel = _interopRequireDefault(require("../nav/UINavItemLabel"));

var _decorators = require("../utils/propTypes/decorators");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _times = require("HubStyleTokens/times");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  overflow: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ICON_SIZE = 'xxs';
var NavListItemTransitionWrapper = (0, _styledComponents.default)(_AccordionTransition.default.defaultProps.Wrapper).withConfig({
  displayName: "UINavListItem__NavListItemTransitionWrapper",
  componentId: "sc-1spanh-0"
})(_templateObject(), function (_ref) {
  var transitioning = _ref.transitioning;
  return transitioning ? 'hidden' : 'visible';
});

var UINavListItem = _react.default.createClass({
  displayName: "UINavListItem",
  propTypes: {
    active: _react.PropTypes.bool.isRequired,
    children: _react.PropTypes.node,
    count: _react.PropTypes.node,
    duration: _react.PropTypes.number,
    hovered: (0, _decorators.hidden)(_react.PropTypes.bool),
    iconLeft: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func]),
    iconRight: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func]),
    itemClassName: _react.PropTypes.string,
    linkComponent: _component.default,
    onOpenChange: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    title: _react.PropTypes.node.isRequired,
    value: _react.PropTypes.node,
    _rootRenderer: _react.PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      active: false,
      duration: parseInt(_times.NAV_LIST_TRANSITION_ANIMATION_TIMING, 10),
      linkComponent: _UILink.default,
      open: false
    };
  },
  handleClick: function handleClick(evt) {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        onOpenChange = _this$props.onOpenChange,
        open = _this$props.open;
    (0, _Functions.callIfPossible)(onClick, evt);

    if (!evt.defaultPrevented) {
      (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent.default)(!open));
    }
  },
  handleBlur: function handleBlur(evt) {
    this.setState({
      isClicked: false
    });
    (0, _Functions.callIfPossible)(this.props.onBlur, evt);
  },
  renderWrappedChildren: function renderWrappedChildren(_ref2) {
    var children = _ref2.children,
        _rootRenderer = _ref2._rootRenderer;
    return (0, _Functions.callIfPossible)(_rootRenderer, children);
  },
  renderChildren: function renderChildren(_ref3) {
    var children = _ref3.children,
        _rootRenderer = _ref3._rootRenderer;

    if (!children) {
      return null;
    }

    return this.renderWrappedChildren({
      children: children,
      _rootRenderer: _rootRenderer
    });
  },
  renderIcon: function renderIcon(icon, className) {
    if (!icon) return null;

    if (_react.default.isValidElement(icon)) {
      return icon;
    }

    if (typeof icon === 'function') {
      var _this$props2 = this.props,
          children = _this$props2.children,
          open = _this$props2.open;
      return icon({
        children: children,
        className: className,
        open: open,
        size: ICON_SIZE
      });
    }

    return _react.default.createElement(_UIIcon.default, {
      className: className,
      name: icon,
      size: ICON_SIZE
    });
  },
  render: function render() {
    var _this = this;

    var _this$props3 = this.props,
        active = _this$props3.active,
        children = _this$props3.children,
        className = _this$props3.className,
        count = _this$props3.count,
        duration = _this$props3.duration,
        __hovered = _this$props3.hovered,
        iconLeft = _this$props3.iconLeft,
        iconRight = _this$props3.iconRight,
        itemClassName = _this$props3.itemClassName,
        Link = _this$props3.linkComponent,
        __onBlur = _this$props3.onBlur,
        __onClick = _this$props3.onClick,
        __onOpenChange = _this$props3.onOpenChange,
        open = _this$props3.open,
        _rootRenderer = _this$props3._rootRenderer,
        title = _this$props3.title,
        __value = _this$props3.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props3, ["active", "children", "className", "count", "duration", "hovered", "iconLeft", "iconRight", "itemClassName", "linkComponent", "onBlur", "onClick", "onOpenChange", "open", "_rootRenderer", "title", "value"]);
    return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
      var hovered = hoverProviderProps.hovered,
          hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
      var classes = (0, _classNames.default)(className, 'private-nav-item', {
        'private-nav-item--active': active,
        'private-nav-item--is-parent': children != null,
        'private-nav-item--has-icon-right': iconRight != null,
        'private-nav-item--has-icon-left': iconLeft != null,
        'private-nav-item--hovered': hovered
      });
      return _react.default.createElement("li", {
        className: itemClassName
      }, _react.default.createElement(Link, (0, _extends2.default)({}, rest, hoverProviderRestProps, {
        "aria-current": active ? 'true' : null,
        className: classes,
        onBlur: _this.handleBlur,
        onClick: _this.handleClick
      }), _this.renderIcon(iconLeft, 'private-nav-item__icon-left'), _react.default.createElement(_UINavItemLabel.default, {
        className: "private-nav-item__label",
        count: count
      }, title), _this.renderIcon(iconRight, 'private-nav-item__icon-right')), _react.default.createElement(_AccordionTransition.default, {
        open: open,
        duration: duration,
        Wrapper: NavListItemTransitionWrapper
      }, _this.renderChildren({
        children: children,
        _rootRenderer: _rootRenderer
      })));
    });
  }
});

var _default = (0, _Controllable.default)(UINavListItem, ['open']);

exports.default = _default;
module.exports = exports.default;